import { defaultCoin } from "~/assets/assets";
import { goBack } from "~/shared_states/modal";
import { ButtonRegular } from "~/widgets/button";
import { Show } from "solid-js";
import { SummaryItem } from "../summary_modal/summary_modal";
import { toRupees } from "~/utils/number";

export function SeeWhyBS(props: {
  amount: number;
  taxAmount: number;
  redeemAmount: number;
  balance: number;
}) {
  return (
    <div class="relative flex h-full w-full flex-col items-center justify-start bg-baseTertiaryLight px-5 py-4">
      <div class="h-1 w-[45px] rounded-[22px] bg-baseTertiaryDark" />

      <h1 class="mb-2 mt-6 text-center text-h4 text-textDark">
        Max card amount is calculated <br /> basis 194(R) adjustments
      </h1>
      <div class="flex items-center justify-center gap-1">
        <p class="text-normal text-textDark">You have:</p>{" "}
        <img src={defaultCoin} alt="" />{" "}
        <p class="text-bold text-coinPercentageOrange">
          {toRupees(props.balance ?? 0)}
        </p>
      </div>

      <div class="w-full px-0 py-4">
        <div class="mb-2.5 h-px border-t border-y-baseTertiaryMedium" />
        <SummaryItem
          class="text-bold text-textDark"
          label="Max card amount"
          value={toRupees(props.amount ?? 0)}
        />
        <div class="flex flex-row items-end justify-between px-0 py-1.5 text-bold text-textDark">
          <div>
            <p>Taxes</p>
            <p class="text-f12 text-textNormal">194(R) adjusted</p>
          </div>
          <p class="text-textDark">{toRupees(props.taxAmount ?? 0)}</p>
        </div>

        <Show when={true}>
          <div class="mb-2.5 h-px border-t border-y-baseTertiaryMedium" />
          <SummaryItem
            class="text-bold text-textDark"
            label="Incentive available to redeem"
            isCoin={true}
            value={toRupees(props.redeemAmount ?? 0)}
          />
        </Show>
      </div>
      <ButtonRegular
        class="mt-5 w-full"
        isEnabled={true}
        onClick={() => goBack()}
      >
        Got it
      </ButtonRegular>
    </div>
  );
}
